import { render, staticRenderFns } from "./TurnstileCaptcha.vue?vue&type=template&id=5b359da1&scoped=true"
import script from "./TurnstileCaptcha.vue?vue&type=script&lang=js"
export * from "./TurnstileCaptcha.vue?vue&type=script&lang=js"
import style0 from "./TurnstileCaptcha.vue?vue&type=style&index=0&id=5b359da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b359da1",
  null
  
)

export default component.exports